import { createTheme } from "@mui/material";
import { esES } from "@mui/x-date-pickers/locales";

export const heyvetTheme = createTheme(
    {
        typography: {
            fontFamily: [
                "Nunito Sans",
                "Manrope",
                "-apple-system",
                "BlinkMacSystemFont",
                '"Segoe UI"',
                "sans-serif",
            ].join(","),
            h1: { fontFamily: "'Poppins', 'Montserrat', sans-serif" },
            h2: { fontFamily: "'Poppins', 'Montserrat', sans-serif" },
            h3: { fontFamily: "'Poppins', 'Montserrat', sans-serif" },
            h4: { fontFamily: "'Poppins', 'Montserrat', sans-serif" },
            h5: { fontFamily: "'Poppins', 'Montserrat', sans-serif" },
            h6: { fontFamily: "'Poppins', 'Montserrat', sans-serif" },
            body1: {
                fontSize: "1rem",
                fontWeight: "400",
            },
        },
        palette: {
            primary: {
                main: "#10B981", // Emerald Green
                contrastText: "#fff",
            },
            secondary: {
                main: "#065F46", // Forest Green
            },
            warning: {
                main: "#F59E0B", // Amber
            },
            background: {
                default: "#FFF7ED", // Warm Cream
                paper: "#fff",
            },
            text: {
                primary: "#0F172A", // Dark Slate
                secondary: "#475569", 
            },
            mode: "light",
        },
        components: {
            MuiButton: {
                defaultProps: {
                    variant: "contained",
                    color: "primary",
                    disableElevation: true,
                },
                styleOverrides: {
                    root: {
                        textTransform: "none",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 600,
                        fontSize: "1rem",
                        borderRadius: "12px",
                        padding: "10px 24px",
                    },
                },
            },
            MuiTextField: {
                defaultProps: {
                    variant: "outlined",
                    fullWidth: true,
                    color: "primary",
                },
                styleOverrides: {
                    root: {
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                        }
                    }
                }
            },
            MuiTypography: {
                defaultProps: {
                    color: "textPrimary",
                },
            },
        },
    },
    esES
);
